/**
 * The hex contract for the accent colour `useChinPalette` publishes.
 *
 * The extracted `accent_color` (from `getDominantColorFromImageUrl` via a Stream
 * attachment field) is always a hex, but CSS `oklch(from …)` would resolve any
 * colour name — including `rebeccapurple` — so the input is narrowed to a hex
 * before it is published as `--accent`, rather than widening that contract by
 * accident.
 */

/**
 * `#abc`, `#aabbcc`, or either without the leading `#`.
 *
 * The optional hash is deliberate: the extractor returns bare hexes often
 * enough that rejecting them would drop the colour. It is also why `toCssHex`
 * exists — `738883` without the `#` is not a valid CSS colour.
 */
export const HEX_PATTERN = /^#?(?:[0-9a-f]{3}|[0-9a-f]{6})$/i

/** Normalizes a hex for CSS, adding the `#` the extractor omits. */
export function toCssHex(hex: string): string {
  const trimmed = hex.trim()
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`
}
